import { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getDemoBookingUrl } from '../config/externalLinks';

/**
 * /demo in the SPA: use build-time Calendly URL in local dev when set;
 * otherwise reload /demo so the backend redirect (DEMO_BOOKING_URL) handles staging/production.
 */
export default function DemoBookingRedirect() {
  useEffect(() => {
    const clientUrl = getDemoBookingUrl();
    window.location.replace(clientUrl ? clientUrl : '/demo');
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',
        gap: 2,
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="body2" color="text.secondary">
        Redirecting to schedule your JobMockAI demo…
      </Typography>
    </Box>
  );
}
